import {__} from "~/ts/library/Translate";
import OperatorApplicationServerSideConfigInterface
    from "~/operatorApplication/ts/service/OperatorApplicationServerSideConfigInterface";

export default function getBuddyListDisplayConfigItems(
    config: OperatorApplicationServerSideConfigInterface,
): BuddyListDisplayConfigItemInterface[] {
    let result = [
        {
            descr: __("Последнее сообщение"),
            getter: () => config.buddyListShowLastMessage,
            setter: (value: boolean) => config.buddyListShowLastMessage = value
        },
        {
            descr: __("Предпросмотр последнего сообщения при наведении"),
            getter: () => config.buddyListShowLastMessageTooltip,
            setter: (value: boolean) => config.buddyListShowLastMessageTooltip = value
        },
        {
            descr: __("Состояние диалога"),
            getter: () => config.buddyListDialogState,
            setter: (value: boolean) => config.buddyListDialogState = value
        },
        {
            descr: __("Время от последнего вопроса"),
            getter: () => config.buddyListShowTimeFromLastQuestion,
            setter: (value: boolean) => config.buddyListShowTimeFromLastQuestion = value
        },
        {
            descr: __("Статистика"),
            getter: () => config.buddyListShowStatistic,
            setter: (value: boolean) => config.buddyListShowStatistic = value
        },
        {
            descr: __("Категории вопросов"),
            getter: () => config.buddyListShowQuestionCategory,
            setter: (value: boolean) => config.buddyListShowQuestionCategory = value
        },
        {
            descr: __("Источник перехода"),
            getter: () => config.buddyListShowReferer,
            setter: (value: boolean) => config.buddyListShowReferer = value
        },
        {
            descr: __("Последняя страница"),
            getter: () => config.buddyListShowLastPage,
            setter: (value: boolean) => config.buddyListShowLastPage = value
        },
        {
            descr: __("Тэги клиента"),
            getter: () => config.buddyListShowClientTags,
            setter: (value: boolean) => config.buddyListShowClientTags = value
        },
        {
            descr: __("Тэги текущего диалога"),
            getter: () => config.buddyListShowDialogTags,
            setter: (value: boolean) => config.buddyListShowDialogTags = value
        }
    ];
    result.push({
        descr: __("Закрепленные операторы"),
        getter: () => config.buddyListShowAttachedOperators,
        setter: (value: boolean) => config.buddyListShowAttachedOperators = value
    });

    result.push(
        {
            descr: __("Группировать чаты по сайтам"),
            getter: () => config.buddyListGroupBySites,
            setter: (value: boolean) => config.buddyListGroupBySites = value
        }
    );
    if (config.buddyListGroupBySites) {
        result.push({
            descr: __("Группировать сайты с одинаковыми доменами"),
            getter: () => config.buddyListGroupSitesByDomains,
            setter: (value: boolean) => config.buddyListGroupSitesByDomains = value
        })
    }
    result.push(...[
        {
            descr: __("Группировать чаты по каналам"),
            getter: () => config.buddyListGroupByIntegrationPlatform,
            setter: (value: boolean) => config.buddyListGroupByIntegrationPlatform = value
        },
        {
            descr: __("Группировать чаты по состоянию"),
            getter: () => config.buddyListGroupByState,
            setter: (value: boolean) => config.buddyListGroupByState = value
        },
    ]);
    if (config.buddyListGroupByState) {
        result.push({
            descr: __("Учитывать при группировке по состоянию - участвуете ли вы в диалоге"),
            getter: () => config.buddyListGroupByStateDependsOnOperator,
            setter: (value: boolean) => config.buddyListGroupByStateDependsOnOperator = value
        });
    }
    //if (config.buddyListGroupBySites) {
        result.push({
            descr: __("Подключенные операторы"),
            getter: () => config.buddyListShowOperators,
            setter: (value: boolean) => config.buddyListShowOperators = value
        });
    //}
    if (config.buddyListShowOperators) {
        result.push({
            descr: __("Показывать операторов только из вашего отдела"),
            getter: () => config.buddyListShowOperatorsOfYourGroupOnly,
            setter: (value: boolean) => config.buddyListShowOperatorsOfYourGroupOnly = value
        });
    }
    return result;
}

export interface BuddyListDisplayConfigItemInterface {
    descr: string;
    getter: () => boolean;
    setter: (value: boolean) => void;
}